










import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import UserForm from "./Form.vue";
import { UserDto } from "@/store/users/user.interface";
import User from "@/store/users";

@Component({
  components: {
    "user-form": UserForm
  }
})
export default class AppUserCreate extends Vue {
  isLoading: boolean = false;
  error: any = "";

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await User.createOne(form);

      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("User Created");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
      this.$toasted.error(this.error);
    }
  }

  async onCancel() {
    this.$router.back();
  }
}
